/** English averages prompts (ADR 0051 part 3). Unchanged from the original inline text. */
export const averagesPrompts = {
    mean: (list: string) => `Find the mean of ${list}.`,
    median: (list: string) => `Find the median of ${list}.`,
    mode: (list: string) => `Find the mode of ${list}.`,
    range: (list: string) => `Find the range of ${list}.`,
};
